/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const OutlineArrowIcRightArrow = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 24 24",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M8 4l8 8-8 8"
  }));
};
export default OutlineArrowIcRightArrow;